import { useState } from "react";
import { Button, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import PhoneOtpField from "screens/UIComponents/PhoneNumberFields/PhoneOtpField";
import { INITIATE_CALL } from "adapters/form.service";
import { toast } from "react-toastify";
import { set } from "lodash";

// Screen-level component: can be directly used in routes.
// You can rename this file and component as needed when wiring routes.
export default function PhoneCallWithOtp({
  squadId = "",
  phoneNumberId = "",
  tenantId = "",
}) {
  const [isVerifyCode, setIsVerifyCode] = useState(false);
  const [loading, setLoading] = useState(false);

  // Set up react-hook-form for the phone field
  const methods = useForm({
    defaultValues: {
      phoneNumber: "",
    },
    mode: "onChange",
  });

  const phoneNumber = methods.watch("phoneNumber");
  const hasPhoneError = !!methods?.formState?.errors?.phoneNumber;

  const handleInitiateCall = async (data) => {
    // TODO: Wire this to your actual call / Vapi logic
    // using the formatted phoneNumber.
    // For now this is a placeholder.
    console.log("Initiate call to:", data.phoneNumber);
    setLoading(true);

    try {
      // Call your INITIATE_CALL function here with necessary payload
      const res = await INITIATE_CALL({
        payload: {
          customer: {
            number: data?.phoneNumber,
          },
          phoneNumberId: phoneNumberId,
          squadId: squadId,
        },
        tenantId,
      });
      console.log("Call initiated:", res);
      toast.success("Call initiated successfully!");
    } catch (error) {
      console.error("Error initiating call:", error);
      toast.error("Failed to initiate call. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // If OTP is enabled in PhoneOtpField, require verification;
  // by default here we enable OTP for the route.
  const enablePhoneOtp = false;
  const isCallDisabled = enablePhoneOtp
    ? !isVerifyCode || hasPhoneError
    : !phoneNumber || hasPhoneError;

  return (
    <div className="h-100 d-flex flex-column justify-content-center align-items-center">
      <div style={{ width: "100%", maxWidth: 420 }} className="border-sm border rounded-4">
        <Typography variant="h6" gutterBottom>
          Phone Calling
        </Typography>
        <form
          onSubmit={methods.handleSubmit((data) => {
            // react-hook-form validation passes here
            handleInitiateCall(data);
          })}
        >
          <PhoneOtpField
            methods={methods}
            name="phoneNumber"
            label={"Phone Number*"}
            errors={methods?.formState?.errors}
            setIsVerifyCode={setIsVerifyCode}
            enableOtp={enablePhoneOtp}
          />

          <div className="d-flex justify-content-end mt-3">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isCallDisabled || loading}
            >
              Initiate Call
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
